<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import AutomationsPageBanner from '@/views/workspaces/settings/AutomationsPageBanner'
import CheckinsAlerts from '@/views/workspaces/settings/CheckinsAlerts'
import CheckInsSchedules from '@/views/workspaces/settings/CheckinsSchedules'

defineOptions({
  name: 'CheckinsAutomationsLayout'
})

const createdSchedule = ref(null)
const store = useStore()

const isShowBannerOnAutomationsPage = computed(() => {
  return store.getters['system/isShowBannerOnAutomationsPage']
})
</script>

<template>
  <div class="cal-Wrapper">
    <AutomationsPageBanner v-if="isShowBannerOnAutomationsPage" />
    <CheckInsSchedules @create-alert-from-reference="createdSchedule = $event" />
    <CheckinsAlerts v-model:created-schedule="createdSchedule" />
  </div>
</template>

<style lang="scss" scoped>
.cal-Wrapper {
  padding: 18px 0 40px 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  --ob-abe-pl: 19px;
}
</style>
